import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { getAllCities, getStates } from '../../../services/states';
import { getCities } from '../../../services/cities';
import { ClientRegistrationContext } from '../../../store';
import { clientRegister, validateClientAdvisorPaymentBill, validateClientAdvisorPaymentBillError, valideteClientAdvisor } from '../../../services/clientRegistration';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import { default as ClientRegistrationTypes } from '../../../store/ClientRegistration/types';
import RadioButtonForm from '../../../components/RadioButtonForm';
import InputDefault from '../../../components/InputDefault';
import InputDate from '../../../components/InputDate';
import ModalInfo from '../../../components/ModalInfo';
import FormTemplate from '../../../components/FormTemplate';
import { clientRegistrationSteps } from '../../../helpers/enum';
import { identificationType } from '../../../helpers/enum';
import { handleChangeIdentification } from '../../../helpers/price';
import { toLatinDate } from '../../../helpers/date';
import colors from '../../../assets/styles/colors';
import SearchField from '../../../components/SearchField';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { Form, FormFooter, FormRow, FormRowInvisible } from '../../../components/FormTemplate/styles';
import {
  Tooltip,
  TooltipTitle,
  TooltipContent,
  InfoCircleImage
} from './styles';
import Loader from '../../../components/Loader';
import infoCircle from '../../../assets/images/info-circle.svg';
import { AditinalDataHeaderDescription } from '../AditionalData/styles';
import InputPhone from '../../../components/InputPhone';
import { getOtpCode } from '../../../services/otp';
import ModalAction from '../../../components/ModalAction';
import { getDataCliente } from '../../../services/clients';
import Select from '../../../components/Select';
import { calculadoraRiesgo, getAllActividadesEconomicas, getGenders, getIdentificationTypes, getPaisesMundo, getPrincipalesActividadesEconomicas } from '../../../services/calculator';
import { useLocation,useHistory } from 'react-router-dom';
import { getPilotoValidacionIdentidad } from '../../../services/desk';
import LoadingModal from '../../../components/ModalFlujoContinuo';

const RegistrationPage = ({ setActiveStep, setLastStep }) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const history = useHistory();
  const { clientRegistration, setClientRegistration } = useContext(ClientRegistrationContext);
  const { control, register, errors, watch, setValue, handleSubmit } = useForm({ defaultValues: clientRegistration.registration });
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalInfoDocumento, setShowModalInfoDocumento] = useState(false);
  const [showModalInfoGenero, setShowModalInfoGenero] = useState(false);
  const [showModalInfoSimulador, setShowModalInfoSimulador] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [idCityExp, setIdCityExp] = useState('');
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [gender, setGender] = useState('');
  const [document, setDocument] = useState('');
  const fields = watch();
  const [titleInfoErrores, setTitleInfoErrores] = useState('');
  const [showModalInfoErrores, setShowModalInfoErrores] = useState(false);
  const [showModalInfoExitoso, setShowModalInfoExitoso] = useState(false);
  const emailValue = useWatch({ control, name: 'email' });
  const [bloquearFechaExpedicion, setBloquearFechaExpedicion] = useState(false);
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [tipoDocumento, setTipoDocumentos] = useState([]);
  const [showGeneros, setShowGeneros] = useState(false);
  const [generos, setGeneros] = useState([]);
  const [showActividadEconomica, setShowActividadEconomica] = useState(false);
  const [actividadEconomicaList, setActividadEconomicaList] = useState([]);
  const [actividadEconomica, setActivity] = useState('');
  const [showActividadEconomica2, setShowActividadEconomica2] = useState(false);
  const [actividadEconomicaList2, setActividadEconomicaList2] = useState([]);
  const [filteredActividadEconomicaList2, setFilteredActividadEconomicaList2] = useState([]);
  const [actividadEconomica2, setActivity2] = useState('');
  const [showPaises, setShowPaises] = useState(false);
  const [countries, setCountries] = useState([{ id: 1, nombre: "Colombia" }, { id: 2, nombre: "Otro país" }]);
  const [anotherCountry, setAnotherCountry] = useState(false);
  const [nacionalidad, setNacionalidad] = useState('');
  const [paisNacimiento, setPaisNacimiento] = useState('');
  const [birthCities, setBirthCities] = useState([]);
  const [showBirthCities, setShowBirthCities] = useState(false);
  const [filteredBirthCities, setFilteredBirthCities] = useState([]);
  const [lugarNacimiento2, setLugarNacimiento2] = useState('');
  const [lugarNacimiento, setLugarNacimiento] = useState('');
  const [anotherDeparment, setAnotherDeparment] = useState(false);
  const [anotherCity, setAnotherCity] = useState(false);
  const [departamentoNacimiento2, setDepartamentoNacimiento2] = useState('');
  const [ciudadNacimiento2, setCiudadNacimiento2] = useState('');
  const [departamentoNacimiento, setDepartamentoNacimiento] = useState('');
  const location = useLocation();
  const [showNacionalidad, setShowNacionalidad] = useState(false);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const LABELS = [
    "Verificando información",
    "Registrando cliente",
    "Validacion riesgo",
    "Espera un momento..."
  ];

  async function setCompleteStep(data) {
    try {
      console.log(data)
      /*if (gender.trim() === ""){
        setShowModalInfoGenero(true);
        return;
      }*/

      const body = {
        idCredito:location.idCredit,
        nacionalidad: nacionalidad.pais,//posible cambio
        cod_municipio: clientRegistration.aditionalData.city.codigo,
        ciiu: actividadEconomica.nombre == 'Otro' ? parseInt(actividadEconomica2.idLegado): parseInt(actividadEconomica.idLegado),
        pagaduria:clientRegistration.pagaduria.nombre

      }
      await calculadoraRiesgo(body);
     

      if (document?.id.trim() === ""){
        setShowModalInfoDocumento(true);
        return;
      }           
      setIsLoading(true);
      data.tipoIdentificacion = document?.id;
      data.genero = gender;
      data.expedicion = idCityExp;

      setClientRegistration({
        type: ClientRegistrationTypes.SET_REGISTRATION_DATA,
        registration: data
      })
      
      let datajson =  {
        tipoIdentificacion: data.tipoIdentificacion,
        identificacion: data.identificacion.replaceAll('.', ''),
        idAsesor:  session.idAsesor,
      }

      await validateClientAdvisorPaymentBillError(datajson); 


      if (clientRegistration.aditionalData.state.nombre != fields.residenceState){
        setTitleInfoErrores("Seleccione un Departamento de la lista");
        setIsLoading(false);
        setShowModalInfoErrores(true);
        return;
      }
      if (clientRegistration.aditionalData.city.nombre != fields.residenceCity){
        setTitleInfoErrores("Seleccione una Ciudad de la lista");
        setIsLoading(false);
        setShowModalInfoErrores(true);
        return;
      }
      setIsLoading(true);
      let fieldsData = fields;

      fieldsData.state = clientRegistration.aditionalData.state;
      fieldsData.city = clientRegistration.aditionalData.city;

      setClientRegistration({
        type: ClientRegistrationTypes.SET_ADITIONAL_DATA,
        data: fieldsData
      });
      const req = new FormData();
      req.append('idSimulacion', clientRegistration.simulacion.idSimulacion);
      req.append('idAsesorAutorizado', clientRegistration.simulacion.idAsesor);
      req.append('idDepartamento', clientRegistration.aditionalData.state?.id);
      req.append('idCiudad', clientRegistration.aditionalData.city?.id);
      req.append('tipoIdentificacion', data.tipoIdentificacion);
      req.append('identificacion', data.identificacion.replaceAll('.', ''));
      req.append('primerNombre', data.primerNombre);
      req.append('segundoNombre', data.segundoNombre);
      req.append('primerApellido', data.primerApellido);
      req.append('segundoApellido', data.segundoApellido);
      req.append('fechaNacimiento', data.fechaNacimiento);
      req.append('fechaExpedicionDocumento', fields.fechaExpedicionDoc);
      req.append('ciudadExpedicionIdentificacion', idCityExp);
      req.append('genero', data.genero.idLegado);
      req.append('celular', fields.celular.replaceAll(' ', ''));
      req.append('email', fields.email);
      req.append('subCanal', 'WEB');
      req.append('archivoIdentificacion1', clientRegistration.identityPhoto[0], clientRegistration.identityPhoto[0].name);
      req.append('archivoIdentificacion2', clientRegistration.identityPhoto[1], clientRegistration.identityPhoto[1].name);
      req.append('soloActualizar', true);
      actividadEconomica.nombre == 'Otro' ? req.append('actividadEconomica', actividadEconomica2.idLegado): req.append('actividadEconomica', actividadEconomica.idLegado);
      req.append('nacionalidad', data.nacionalidad);
      req.append('paisNacimiento', data.paisNacimiento);
      req.append('idDepartamentoResidencia',clientRegistration.aditionalData.state.id);
      req.append('idCiudadResidencia',clientRegistration.aditionalData.city.id);
      anotherCountry ? (req.append('lugarNacimiento', (data.lugarNacimiento + " ("+data.departamentoExpedicionExtranjero+ ")"  ))) :  req.append('lugarNacimiento', lugarNacimiento2.nombre);
      
      const response = await clientRegister(req, clientRegistration.simulacion.idSimulacion);
      const data2 = {
        idCliente: response.data.idCliente,
        idCredito: response.data.idCredito,
      }
      data = data2;
      setClientRegistration({
        type: ClientRegistrationTypes.SET_CREDIT_ID,
        data
      });
      
      /* Nuevo email a cliente para Habeas Data */
      const habeasData = {
        idCredito: response.data.idCredito,
        idCliente: response.data.idCliente,
        idUsuario: 0,
        otp: 0
      }

      if(clientRegistration.simulacion) {
        habeasData.idUsuario = clientRegistration.simulacion.idAsesor
      } else {
        habeasData.idUsuario = clientRegistration.simulacion.idAsesor
      }

      await getOtpCode(habeasData);

     
      
      setIsLoading(false);
      handleOpenModal();
    } catch (error) {
      console.log(error)
      setIsLoading(false);
      setShowModalInfo(false);
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    history.push({
      pathname: '/admin/client-registration',
      step: 6,
      idCredit: location.idCredit,
      idSimulation: location.idSimulacion
    });
  };

  async function closeModalInfoProspecting() {
    try {
      setIsLoading(true);
      const oficinaAutovalidation = await getPilotoValidacionIdentidad(clientRegistration.credito.idOficina);
      if(!oficinaAutovalidation.data.unificado){
        history.push('/admin/dashboard');
      }else{
        setShowModalInfoExitoso(false);
        setActiveStep(clientRegistrationSteps.PROSPECTING)
        setLastStep(clientRegistrationSteps.REGISTRATION)
      }
      setIsLoading(false);
     } catch (error) {
      
     }
    
  }

  function setBackStep() {
    let data = fields;
    data.tipoIdentificacion = clientRegistration.registration.tipoIdentificacion;
    data.genero = clientRegistration.registration.genero;

    setClientRegistration({
      type: ClientRegistrationTypes.SET_REGISTRATION_DATA,
      registration: data
    })

    setActiveStep(clientRegistrationSteps.IDENTITY_FOTO);
  }

  /*function setIdentificationRadioChecked(radio) {
    setValue('tipoIdentificacion',radio.value);
    setDocument(radio.value);
  }*/

  function setIdentificationRadioChecked(radio) {
    setValue('tipoIdentificacion', radio.nombre)
    setDocument(radio)
  }

  function setGenderRadioChecked(genero) {
    setValue('genero',genero.idLegado);
    setGender(genero);
  }

 async function setActividadEconomica(actividad) {
    setValue('actividadEconomica',actividad.nombre);
    setValue('actividadEconomica2',actividad.nombre);
    setActivity(actividad)
    if(actividad?.nombre === 'Otro'){
      setIsLoading(true)
      const allActivities = await getAllActividadesEconomicas();
      setActividadEconomicaList2(allActivities.data)
      setIsLoading(false)
    }
  }


  function closeModalInfo() {
    setShowModalInfo(false);
  }

  function onChangeIdentification(e) {
    setValue('identificacion', handleChangeIdentification(e.target.value))
  }

  function setSelectedCity(city) {
    setValue('city', city.nombre);
    setIdCityExp(city.id);
    setShowCity(false);
  }

  function setActividadEconomica2(actividadEconomica) {
    setValue('actividadEconomica2', actividadEconomica.nombre);
    setActivity2(actividadEconomica)
    setShowActividadEconomica2(false);
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);
      setValue('state', state.nombre);

      if(fields.city) {
        setValue('city', '');
        setShowCity(false);
      }

      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  

  function searchInActivities(e) {
    setShowActividadEconomica2(true);
    let filtered = actividadEconomicaList2.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredActividadEconomicaList2(filtered);
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    let filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    let filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function nombresPart(nombres, part) {
    var parts = nombres.split(' ', 4);
    return parts.length < part ? '' :
        // Caso Nombre y Apellido
        parts.length == 2 ? [ parts[0], '', parts[1], '' ][part] :
        // Cualquier otro caso
        parts[part];
  }

  async function initializedStateComponent() {
    try {
      const states = await getStates();
      setStates(states.data);
      if (fields.state){
        const cities = await getCities("CO>"+fields.state.replace('De','de').replace(' Y ',' y '));
        setCities(cities.data);
      }

      const response = await getAllCities();
      response.data.forEach(function (objeto) {
        var id = objeto.id.split('>')[1];
        objeto.nombre = objeto.nombre + ' (' + id + ')';
      });
      setBirthCities(response.data);
      if(clientRegistration.cliente.lugarNacimiento) selectBirthCity(response.data.find(city => city.nombre === clientRegistration.cliente.lugarNacimiento))

      const identificationTypes = await getIdentificationTypes();

      setTipoDocumentos(identificationTypes.data);
      const identificacion = identificationTypes.data.find(item => (item.id === clientRegistration.cliente?.tipoIdentificacion));
      const genders = await getGenders();
      console.log(clientRegistration.cliente?.genero)
      const genero = genders.data.find(item => (item.nombre === clientRegistration.cliente?.genero));
      const actividades = await getPrincipalesActividadesEconomicas();
      const paises = await getPaisesMundo();

      const transformedCountries = paises.data.map(item => ({
        id: item.id,
        nivel: item.nivel,
        nombre: item.nacionalidad,
        pais: item.nombre
      }));

      setNacionalidades(transformedCountries);
      if(clientRegistration.cliente.nacionalidad) setNacionalidad(transformedCountries.find(pais => pais.nombre === clientRegistration.cliente.nacionalidad))
      setCountries(paises.data);
      const pais = paises.data.find(item => (item.nombre === clientRegistration.cliente?.paisNacimiento));
      selectPaises(pais);
      setActividadEconomicaList(actividades.data)
      setGeneros(genders.data);
      setGender(genero)
      setDocument(identificacion);
      const clientData = await getDataCliente(clientRegistration.clienteFull.identificacion);
      if(clientData.data.fechaExpedicion){
        setValue('fechaExpedicionDoc', clientData.data.fechaExpedicion)
        setBloquearFechaExpedicion(true);
      }

      clientData.data.primerNombre ? setValue('primerNombre',clientData.data.primerNombre) : setValue('primerNombre', clientRegistration.cliente.primerNombre === null && nombresPart(clientRegistration.cliente.nombres, 0) || clientRegistration.cliente.primerNombre);
      clientData.data.segundoNombre ? setValue('segundoNombre',clientData.data.segundoNombre) :  setValue('segundoNombre', clientRegistration.cliente.segundoNombre === null  && nombresPart(clientRegistration.cliente.nombres, 1) || clientRegistration.cliente.segundoNombre);
      clientData.data.primerApellido ? setValue('primerApellido',clientData.data.primerApellido) : setValue('primerApellido', clientRegistration.cliente.primerApellido === null && nombresPart(clientRegistration.cliente.nombres, 2) || clientRegistration.cliente.primerApellido);
      clientData.data.segundoApellido ? setValue('segundoApellido',clientData.data.segundoApellido) : setValue('segundoApellido', clientRegistration.cliente.segundoApellido === null && nombresPart(clientRegistration.cliente.nombres, 3) || clientRegistration.cliente.segundoApellido);
      setValue('identificacion', clientRegistration.cliente.identificacion);
      await autoCompleteData();
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }

  function autoCompleteData() {
    if (clientRegistration.aditionalData.state) {
      setValue('residenceState', clientRegistration.aditionalData.state.nombre)
    } else if (clientRegistration.clienteFull.ciudadResidencia && clientRegistration.clienteFull.ciudadResidencia.departamento && clientRegistration.clienteFull.ciudadResidencia.departamento.split('>')[1] != 'Indefinido') {
      setSelectedState({ id: clientRegistration.clienteFull.ciudadResidencia.departamento, nombre: clientRegistration.clienteFull.ciudadResidencia.departamento.split('>')[1] });
    }

    if (clientRegistration.aditionalData.city) {
      setValue('residenceCity', clientRegistration.aditionalData.city.nombre)
    } else if (clientRegistration.clienteFull.ciudadResidencia && clientRegistration.clienteFull.ciudadResidencia.nombre && clientRegistration.clienteFull.ciudadResidencia.nombre != 'Indefinido') {
      setSelectedCity({ id: clientRegistration.clienteFull.ciudadResidencia.id, nombre: clientRegistration.clienteFull.ciudadResidencia.nombre });
    }

    if (clientRegistration.cliente.email) {
      setValue('email', clientRegistration.cliente.email)
    }

    if (clientRegistration.cliente.celular) {
      setValue('celular', clientRegistration.cliente.celular)
    }
    if(clientRegistration.cliente.genero == 'M'){
      setGenderRadioChecked({id: 6,nombre: "Masculino", idLegado: "M",idPricing: "M"})
    }
    if(clientRegistration.cliente.genero == 'F'){
      setGenderRadioChecked({id: 7,nombre: "Femenino", idLegado: "F",idPricing: "F"})
    }
  }

  async function setSelectedResidenceState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);

      setValue('residenceState', state.nombre);
      setClientRegistration({
        type: ClientRegistrationTypes.SET_SELECTED_STATE,
        state
      });

      if(fields.residenceCity) {
        setValue('residenceCity', '');
        setClientRegistration({
          type: ClientRegistrationTypes.SET_SELECTED_CITY,
          city: {}
        });

        setShowCity(false);
      }

      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function setSelectedResidenceCity(city) {
    setValue('residenceCity', city.nombre);
    setClientRegistration({
      type: ClientRegistrationTypes.SET_SELECTED_CITY,
      city
    });

    setShowCity(false);
  }

  function selectPaises(pais) {
    setPaisNacimiento(pais)
    //setValue('nacionalidad', pais?.nacionalidad);
    setValue("paisNacimiento2", pais?.nombre);
    setValue('paisNacimiento', pais?.nombre);
   if(pais?.nombre == 'Colombia'){
    setAnotherCountry(false);
   }else{
    setAnotherCountry(true)
   }
  }

  function closeModalInfo() {
    setShowModalInfo(false);
    setActiveStep(clientRegistrationSteps.PROSPECTING)
    setLastStep(clientRegistrationSteps.ADITIONAL_DATA)
  }

  useEffect(() => {
    setIsLoading(true);
    initializedStateComponent();

    /* Autocompletado */
    setValue('fechaNacimiento', clientRegistration.cliente.fechaNacimiento);
    setValue('primerNombre', clientRegistration.cliente.primerNombre === null && nombresPart(clientRegistration.cliente.nombres, 0) || clientRegistration.cliente.primerNombre);
    setValue('segundoNombre', clientRegistration.cliente.segundoNombre === null  && nombresPart(clientRegistration.cliente.nombres, 1) || clientRegistration.cliente.segundoNombre);
    setValue('primerApellido', clientRegistration.cliente.primerApellido === null && nombresPart(clientRegistration.cliente.nombres, 2) || clientRegistration.cliente.primerApellido);
    setValue('segundoApellido', clientRegistration.cliente.segundoApellido === null && nombresPart(clientRegistration.cliente.nombres, 3) || clientRegistration.cliente.segundoApellido);
    setValue('identificacion', clientRegistration.cliente.identificacion);
    //setDocument(clientRegistration.cliente.tipoIdentificacion);
    /*if(clientRegistration.cliente.genero)
      setGenderRadioChecked({ key: clientRegistration.cliente.genero, value: clientRegistration.cliente.genero});*/
    if(clientRegistration.cliente.fechaExpedicionDocumento)
      setValue('fechaExpedicionDoc', clientRegistration.cliente.fechaExpedicionDocumento);
    if(clientRegistration.cliente.ciudadExpedicion) {
      setSelectedState({id: clientRegistration.cliente.ciudadExpedicion.departamento, nombre: clientRegistration.cliente.ciudadExpedicion.departamento && clientRegistration.cliente.ciudadExpedicion.departamento.split('>')[1] || ''});
      setSelectedCity({id: clientRegistration.cliente.ciudadExpedicion.id, nombre: clientRegistration.cliente.ciudadExpedicion.nombre})
    }
    
    setIsLoading(false);
    /*let data = fields;
    let nombreOCR = data.primerNombre + data.segundoNombre + data.primerApellido + data.segundoApellido;
    if (
        (!document || document.trim() === "" || document.trim() !== clientRegistration.cliente.tipoIdentificacion) ||
        (!data.identificacion || data.identificacion.trim() === "" || data.identificacion.replaceAll('.', '') !== clientRegistration.cliente.identificacion) ||
        (!nombreOCR || nombreOCR.trim() === "" || nombreOCR.trim().replaceAll(' ', '').toUpperCase() !== clientRegistration.cliente.nombres.trim().replaceAll(' ', '').toUpperCase()) ||
        (!data.fechaNacimiento || data.fechaNacimiento === "" || data.fechaNacimiento !== clientRegistration.cliente.fechaNacimiento)
      ){
      setShowModalInfoSimulador(true);
    }*/
    return () => {
      setCities([]);
      setStates([]);
      setFilteredCities([]);
      setFilteredStates([]);
    };
  }, [])

  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value?.toLowerCase();
    setValue('email', lowercaseEmail);
  }
    useEffect(() => {
      const lowercaseEmail = emailValue?.toLowerCase();
      setValue('email', lowercaseEmail);
    }, [emailValue, setValue]);

    
  async function selectBirthCity(city) {
    setValue('lugarNacimiento', city?.nombre);
    setValue('lugarNacimiento2', city?.nombre);
   setLugarNacimiento2(city)

    setShowBirthCities(false);
  }
    
  function searchInBirthCities(e) {
    setShowBirthCities(true);
    let filtered = birthCities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredBirthCities(filtered);
  }

  return (
    <FormTemplate 
      idForm="registration-step-page"
      activeStep="2/2"
      stepLabel={
        <>
          Registro del cliente
          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-simulador-info'/>
        </>
      }>
    <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
      <FormRow>
      <Select
            error={errors.tipoDocumento}
            setShow={setShowTipoDocumentos}
              show={showTipoDocumentos}
              defaultValue={document?.nombre}
              setSelected={setIdentificationRadioChecked}
              list={tipoDocumento}
              placeholder="Seleccionar..."
              label="Tipo de documento"
              name="tipoIdentificacion"
              id="tipoIdentificacion"
              register={register({ required: "Este dato es obligatorio" })}
            />
          <Controller
          name="identificacion"
          control={control}
          value={clientRegistration.registration.identificacion}
          render={() => (
            <InputDefault
              readOnly
              name="identificacion"
              label="Número de documento de identidad"
              register={register({ required: "Este dato es obligatorio" })}
              id="identificacion"
              error={errors.identificacion}
              maxLength={clientRegistration.registration.tipoIdentificacion === 'CE' ? identificationType.ce.max : identificationType.cc.max}
              minLength={clientRegistration.registration.tipoIdentificacion === 'CE' ? identificationType.ce.min : identificationType.ce.min}
              onChange={onChangeIdentification}
            />
          )}
        />
      </FormRow>
      <FormRow col="2">
        
      </FormRow>
      <FormRow col="2">
        <Controller
          readOnly
          as={InputDefault}
          control={control}
          label="Primer Nombre"
          name="primerNombre"
          register={register({ required: "Este dato es obligatorio" })}
          id="primerNombre"
          error={errors.primerNombre}
          value={clientRegistration.registration.primerNombre} />
        <Controller
          readOnly
          as={InputDefault}
          control={control}
          label="Segundo Nombre"
          name="segundoNombre"
          register={register}
          id="segundoNombre"
          value={clientRegistration.registration.segundoNombre} />
      </FormRow>
      <FormRow col="2">
        <Controller
          readOnly
          as={InputDefault}
          control={control}
          label="Primer Apellido"
          name="primerApellido"
          register={register({ required: "Este dato es obligatorio" })}
          id="primerApellido"
          error={errors.primerApellido}
          value={clientRegistration.registration.primerApellido} />
        <Controller
          readOnly
          as={InputDefault}
          control={control}
          label="Segundo Apellido"
          name="segundoApellido"
          register={register}
          id="segundoApellido"
          value={clientRegistration.registration.segundoApellido} />
      </FormRow>
      <FormRow col="2">
        <InputDate
          
          aria-required
          type="date"
          label="Fecha de nacimiento"
          name="fechaNacimiento"
          register={register({ required: "Este dato es obligatorio" })}
          id="fechaNacimiento"
          error={errors.fechaNacimiento}
          onBlur={() => { }} />
        <InputDate
        disabled={bloquearFechaExpedicion}
          aria-required
          type="date"
          label="Fecha Expedición Doc."
          name="fechaExpedicionDoc"
          register={register({ required: "Este dato es obligatorio" })}
          id="fechaExpedicionDoc"
          error={errors.fechaExpedicionDoc}
          onBlur={() => { }} />
      </FormRow>      
      <FormRow col="2">
        <SearchField
          disabled={true}
          label="Departamento de Expedición"
          name="state"
          id="state"
          show={showState}
          list={filteredStates}
          selectField={setSelectedState}
          searchInList={searchInState}
          register={register({ required: "Este dato es obligatorio" })}
          placeholder="Buscar..."
          error={errors.state}
          />
        <SearchField
          label="Ciudad o Municipio de Expedición"
          name="city"
          id="city"
          show={showCity}
          list={filteredCities}
          selectField={setSelectedCity}
          searchInList={searchInCities}
          register={register({ required: "Este dato es obligatorio" })}
          placeholder="Buscar..."
          error={errors.city}
          disabled={true} />
      </FormRow>
      <FormRow col="2">
          <Select
            setShow={setShowPaises}
            show={showPaises}
            defaultValue={paisNacimiento?.nombre}
            setSelected={selectPaises}
            list={countries}
            placeholder="Seleccionar..."
            label="Pais de nacimiento"
            name="paisNacimiento"
            id="paisNacimiento"
            error={errors.paisNacimiento}
            register={register({ required: "Este dato es obligatorio" })}
          />
          <Select
            setShow={setShowNacionalidad}
            show={showNacionalidad}
            defaultValue={nacionalidad?.nombre}
            setSelected={setNacionalidad}
            list={nacionalidades}
            placeholder="Seleccionar..."
            label="Nacionalidad"
            name="nacionalidad"
            id="nacionalidad"
            error={errors.nacionalidad}
            register={register({ required: "Este dato es obligatorio" })}
          />
          {/** 
          <Controller
            type="text"
            as={InputDefault}
            control={control}
            register={register({ required: "Este dato es obligatorio" })}
            label="Nacionalidad"
            name="nacionalidad"
            id="nacionalidad"
            error={errors.nacionalidad}
            value={nacionalidad?.nombre}
            readOnly={true}
          />*/}
        </FormRow>
      <FormRow col="2">
        {!anotherCountry && 
      <SearchField
              label="Ciudad de Nacimiento"
              name="lugarNacimiento2"
              id="lugarNacimiento2"
              show={showBirthCities}
              list={filteredBirthCities}
              defaultValue={lugarNacimiento2?.nombre}
              selectField={selectBirthCity}
              searchInList={searchInBirthCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
            }
              {anotherCountry && 
               <Controller
               type="text"
               as={InputDefault}
               control={control}
               error={errors.Departamento}
               register={register({ required: "Este dato es obligatorio" })}
               label="Departamento de Nacimiento"
               name="departamentoExpedicionExtranjero"
               id="departamentoExpedicionExtranjero"
               value={departamentoNacimiento} />
              }
        
        <div style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
          <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.lugarNacimiento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="lugarNacimiento"
              id="lugarNacimiento"
              value={lugarNacimiento} />
          </div>
        
      <Select
              error={errors.genero}
              setShow={setShowGeneros}
              show={showGeneros}
              defaultValue={gender?.nombre}
              setSelected={setGenderRadioChecked}
              list={generos}
              placeholder="Seleccionar..."
              label={<div>Género <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-genero' /></div>}
              name="genero"
              id="genero"
              register={register({ required: "Este dato es obligatorio" })}
            /> 
            <Tooltip
              id='tooltip-genero'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
              </TooltipTitle>
              <TooltipContent>
              El Género debe corresponder al señalado en la identificación.
              </TooltipContent>
            </Tooltip>
      </FormRow>
      <FormRow>
      {/*!anotherCountry && 
      <SearchField
              label="Departamento de Nacimiento"
              name="DepartamentoNacimiento2"
              id="DepartamentoNacimiento2"
              show={showBirthCities}
              list={filteredBirthCities}
              defaultValue={departamentoNacimiento2?.nombre}
              selectField={selectBirthCity}
              searchInList={searchInBirthCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
          */}
       {/* <div style={anotherDeparment ? { display: 'grid' } : { display: 'none' }}>
          <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.Departamento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="Departamento"
              id="Departamento"
              value={lugarNacimiento} />
          </div> */}
      </FormRow>
      <FormRow>
      {/*!anotherCountry && 
      <SearchField
              label="Departamento de Nacimiento"
              name="DepartamentoNacimiento2"
              id="DepartamentoNacimiento2"
              show={showBirthCities}
              list={filteredBirthCities}
              defaultValue={departamentoNacimiento2?.nombre}
              selectField={selectBirthCity}
              searchInList={searchInBirthCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
        */}
        {/*<div style={anotherDeparment ? { display: 'grid' } : { display: 'none' }}>
          <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.Departamento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Departamento de Nacimiento"
              name="Departamento"
              id="Departamento"
              value={lugarNacimiento} />
          </div>*/}
      </FormRow>
      <FormRow>
      {/*!anotherCity && 
      <SearchField
              label="Ciudad de Nacimiento"
              name="ciudadNacimiento"
              id="ciudadNacimiento"
              show={showBirthCities}
              list={filteredBirthCities}
              defaultValue={departamentoNacimiento2?.nombre}
              selectField={selectBirthCity}
              searchInList={searchInBirthCities}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.lugarNacimiento2} />
        */}
        {/** <div style={anotherCountry ? { display: 'grid' } : { display: 'none' }}>
          <Controller
              type="text"
              as={InputDefault}
              control={control}
              error={errors.Departamento}
              register={register({ required: "Este dato es obligatorio" })}
              label="Ciudad de Nacimiento"
              name="ciudadNacimiento"
              id="ciudadNacimiento"
              value={lugarNacimiento} />
          </div>*/}
      </FormRow>
      <FormRow>
      <Select
              error={errors.actividadEconomica}
              setShow={setShowActividadEconomica}
              show={showActividadEconomica}
              defaultValue={actividadEconomica?.nombre}
              setSelected={setActividadEconomica}
              list={actividadEconomicaList}
              placeholder="Seleccionar..."
              label="Actividad Económica"
              name="actividadEconomica"
              id="actividadEconomica"
              //register={register({ required: "Este dato es obligatorio" })}
            />
            
            {actividadEconomica?.nombre == 'Otro' && 
            <SearchField
            label="Código CIIU"
            name="actividadEconomica2"
            id="actividadEconomica2"
            show={showActividadEconomica2}
            list={filteredActividadEconomicaList2}
            selectField={setActividadEconomica2}
            searchInList={searchInActivities}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.actividadEconomica2} />
        }
      </FormRow>
        {/*<AditinalDataHeaderDescription>
          Finaliza la captura de datos
        </AditinalDataHeaderDescription>*/}
        <FormRow col="2" style={{display:'none'}}>
          <Controller
            as={InputPhone}
            control={control}
            label="Celular"
            name="celular"
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                message: "Error en el número, ingresa uno válido",
              },
            })}
            id="celular"
            error={errors.celular}
            mask="999 999 99 99"
            value={clientRegistration.aditionalData.celular} />
          <Controller
            as={InputDefault}
            control={control}
            label="Correo Electrónico"
            name="email"
            onChange={onChangeEmail}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "El correo electrónico tiene un formato inválido",
              },
            })}
            id="email"
            error={errors.email}
            value={clientRegistration.aditionalData.email} />
        </FormRow>
        <FormRow col="2">
          <SearchField
            label="Departamento de Residencia"
            name="residenceState"
            id="residenceState"
            show={showState}
            list={filteredStates}
            defaultValue={clientRegistration.aditionalData.state.nombre}
            selectField={setSelectedResidenceState}
            searchInList={searchInState}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.state} />
          <SearchField
            label="Ciudad o Municipio de Residencia"
            name="residenceCity"
            id="residenceCity"
            show={showCity}
            list={filteredCities}
            defaultValue={clientRegistration.aditionalData.city.nombre}
            selectField={setSelectedResidenceCity}
            searchInList={searchInCities}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.city}
            disabled={!clientRegistration.aditionalData.state} />
        </FormRow>
      <FormFooter justify="space-between">
        <DefaultLargeButton type="button" onClick={() => setBackStep()}>Volver</DefaultLargeButton>
        <SecondaryLargeButton type="submit">Siguiente </SecondaryLargeButton>
      </FormFooter>
      {isLoading && <Loader />}
      <Tooltip 
        id='tooltip-simulador-info'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Información del cliente registrada en el simulador:
        </TooltipTitle>
        <br></br>
        <TooltipTitle>
          Tipo de Identificación
        </TooltipTitle>
        <TooltipContent>
          {clientRegistration.cliente.tipoIdentificacion}
        </TooltipContent>
        <TooltipTitle>
          Número de Identificación
        </TooltipTitle>
        <TooltipContent>
          {clientRegistration.cliente.identificacion}
        </TooltipContent>
        <TooltipTitle>
          Nombre del cliente
        </TooltipTitle>
        <TooltipContent>
          {clientRegistration.cliente.nombres}
        </TooltipContent>
        <TooltipTitle>
          Fecha de nacimiento
        </TooltipTitle>
        <TooltipContent>
          {clientRegistration.cliente.fechaNacimiento}
        </TooltipContent>
      </Tooltip>
      
    </Form>
    <LoadingModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        idCredito={location.idCredit}
        estadoEsperado='PROSPECCION_CLIENTE_EXITOSA'
        labels={LABELS}
        />
    <ModalInfo
      open={showModalInfo}
      setShowModal={closeModalInfo}
      title="Cliente existente"
      description="El cliente que estás registrando ya existe en el sistema. Por favor contacta al líder o director de la oficina en tu ciudad."
      backgroundIcon={colors.bgDanger}
      bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    <ModalInfo
      open={showModalInfoDocumento}
      setShowModal={setShowModalInfoDocumento}
      title="Error en el Tipo de Documento"
      description="Seleccione un Tipo de Documento"
      backgroundIcon={colors.bgDanger}
      bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    <ModalInfo
      open={showModalInfoGenero}
      setShowModal={setShowModalInfoGenero}
      title="Error en el Género"
      description="Seleccione un Género"
      backgroundIcon={colors.bgDanger}
      bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    <ModalInfo
      open={showModalInfoSimulador}
      setShowModal={setShowModalInfoSimulador}
      title="Error coincidencia en datos básicos"
      description="Los datos básicos del cliente no coinciden contra la información registrada en el simulador 1. Por favor valida y edita los datos que correspondan en esta pantalla."
      backgroundIcon={colors.bgDanger}
      bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoErrores}
        setShowModal={setShowModalInfoErrores}
        title={titleInfoErrores}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalAction
        open={showModalInfoExitoso}
        actionFunctionDownButton={() => closeModalInfoProspecting()}
        title={"Cliente exitosamente registrado"}
        actionLabelFunctionDownButton="Continuar"
        description={"Hasta que pueda retomar la solicitud, esta se encontrará en el apartado “Mis solicitudes - Pendientes por radicar”."}
        bodyIcon={<BsCheck id="message"  size={32} color={colors.white} />}
        backgroundIcon={colors.textHyperlink} />
    </FormTemplate>
  )
}

export default RegistrationPage
